type GuestGuardProps = {
  children: React.ReactNode;
};

const GuestGuard = ({ children }: GuestGuardProps) => {
  return <>{children}</>;
};

export default GuestGuard;
